"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OUTFLOW_AS_INCOME_CONFIRM = exports.OUTFLOW_AS_INCOME_WARNING = exports.OUTFLOW_AS_INCOME_TITLE = exports.RULE_RETROACTIVE_NOTICE = void 0;
exports.ruleRecategorizedSummary = ruleRecategorizedSummary;
exports.categorizeOptionsCopy = categorizeOptionsCopy;
exports.isOutflowFiledAsIncome = isOutflowFiledAsIncome;
/**
 * What a new category rule did to past transactions (CAT-006).
 *
 * Both clients create rules with `apply_retroactively: true`, and the backend then
 * recategorises every past transaction that matches, including ones the user
 * categorised themselves. It used to say only "Rule created." whether it changed
 * nothing or a thousand rows. `POST /category-rules/` now returns
 * `recategorized_count`; this turns it into the sentence both clients show.
 *
 * `null` when the count is unknown or the rule was not retroactive, so the caller
 * shows nothing rather than a number it does not have.
 */
function ruleRecategorizedSummary(count) {
    if (count == null)
        return null;
    if (count === 0)
        return "No past transactions matched it.";
    if (count === 1)
        return "1 past transaction was recategorized.";
    return `${count.toLocaleString("en-US")} past transactions were recategorized.`;
}
/** Said before saving, so the overwrite is not a surprise (CAT-006). */
exports.RULE_RETROACTIVE_NOTICE = "Saving also recategorizes every past transaction that matches, including ones you categorized yourself. Deleting the rule later does not undo that.";
function categorizeOptionsCopy(merchantName, counterparty, categoryName) {
    const scope = counterparty ? "payments with" : "transactions from";
    const who = counterparty || merchantName;
    const option = (label, before, after) => ({
        label,
        before,
        who,
        after,
        description: `${before} ${who} ${after}`,
    });
    return {
        applyToSimilar: option("Apply to similar transactions", `Categorize all existing ${scope}`, "the same way, including ones you categorized yourself."),
        saveAsRule: option("Save as a rule", `Auto-categorize future ${scope}`, `as ${categoryName ?? ""}.`),
    };
}
/**
 * Filing an outflow as Income (BEN-141 FP-054). A payment filed under Income
 * drops out of spending, so a purchase vanishes from every total; with "apply to
 * similar" or a rule it keeps doing so. Clawed-back pay is a real reason to do it,
 * so neither client hides Income for an outflow: both ask first, in these words
 * (Paul, 2026-10-06).
 *
 * `isOutflow` is the row's direction as the client already knows it, not an
 * amount: the clients' sign conventions differ (Plaid writes money in as
 * negative; the demo seed writes it as positive).
 */
exports.OUTFLOW_AS_INCOME_TITLE = "File this payment as income?";
exports.OUTFLOW_AS_INCOME_WARNING = "Filing a payment as income removes it from your spending. Is that what you meant?";
exports.OUTFLOW_AS_INCOME_CONFIRM = "File as income";
function isOutflowFiledAsIncome(isOutflow, parentName) {
    // Case-insensitive: mobile files under "Income", web keys parents "income".
    return isOutflow && parentName?.toLowerCase() === "income";
}
//# sourceMappingURL=ruleCopy.js.map